import React from "react";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import CardView from "../../../../../../components/common/CardView";
import Search from "../../../../../../components/Search";
import Table from "../../../../../../components/Table";

import EnrolleesPresenter from "./EnrolleesPresenter";
import Progress from "../../../../../../components/Progress";

class Attendees extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new EnrolleesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "enroll_training";
  }

  async componentDidMount() {
    this.presenter.init(this.props.training); // Pass the training prop
    const objects = await findObjectUseCase().execute("enroll_training");
    console.log("OBJECTTSSSS", objects);
    this.setState({ training: objects });
    this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    // console.log("SCHEMMAAA", schema.fields);
    // const schema1 = this.getSchema("management_training");
    // console.log("SCHEMA 1", schema1.fields);

    // const newSchema = { ...schema.fields, ...schema1.fields };
    // console.log("newSchema", newSchema);
    const { objects, count, current, limit, loading } = this.state;

    const exludeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "training" &&
        fields !== "stats"
    );

    if (!schema) return <Progress />;
    return (
      <>
        <div style={{ margin: "1rem 0" }}>
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>
        </div>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-primary">Attendees</h4>
                </div>
              </CardView>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...exludeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default Attendees;
